import { AgGridReact, AgGridReactProps } from "ag-grid-react";

import { themeQuartz } from "ag-grid-community";
import { Color } from "src/elements";

export const customTheme = themeQuartz.withParams({
  accentColor: Color.primary,
  fontFamily: "Mulish",
  fontSize: 12,
  headerBackgroundColor: Color.primaryActive,
  headerTextColor: Color.white,
  headerFontWeight: 700,
  headerHeight: 30,
  borderRadius: 2,
  iconSize: 14,
});

export const AgGridTable = (props: AgGridReactProps) => {
  return (
    <AgGridReact
      rowHeight={40}
      theme={customTheme}
      suppressColumnVirtualisation
      maintainColumnOrder
      alwaysShowHorizontalScroll={false}
      alwaysShowVerticalScroll={false}
      scrollbarWidth={10}
      pagination={false}
      undoRedoCellEditing
      className="ag-grid-table"
      {...props}
    />
  );
};
